import { GROUPS, PREFIX_PROXY } from '@/service/apiConf';
import { deleteRes, get, patchJSON, patchJsonPatch, postJSON, putJSON } from '@/service/request';
import { GetWorkloadListParams } from './deployment.api';

/** 请求参数与工作负载列表一样, 接口路径改变了 */
export const getStatefulSetList = (cluster: string, params: GetWorkloadListParams): Promise<any> =>
  get(`${PREFIX_PROXY.vapis(GROUPS.statefulset)}/statefulsets`, params);

export const getStatefulSetDetail = ({
  cluster,
  namespace,
  statefulset,
}: {
  cluster: string;
  namespace: string;
  statefulset: string;
}): Promise<any> =>
  get(`${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/statefulsets/${statefulset}`);

export const postCreateStatefulSet = ({
  cluster,
  namespace,
  data,
  dryRun,
}: {
  cluster: string;
  namespace: string;
  data: any;
  dryRun?: string;
}): Promise<any> =>
  postJSON(`${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/statefulsets`, data, {
    params: { dryRun },
  } as any);
export const putEditStatefulSet = ({
  cluster,
  namespace,
  statefulset,
  data,
}: {
  cluster: string;
  namespace: string;
  statefulset: string;
  data: any;
}): Promise<any> =>
  putJSON(
    `${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/statefulsets/${statefulset}`,
    data,
  );

export const patchEditStatefulSet = ({
  cluster,
  namespace,
  statefulset,
  data,
}: {
  cluster: string;
  namespace: string;
  statefulset: string;
  data: any;
}): Promise<any> =>
  patchJSON(
    `${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/statefulsets/${statefulset}`,
    data,
  );

export const patchEditStatefulSet2 = ({
  cluster,
  namespace,
  statefulset,
  data,
}: {
  cluster: string;
  namespace: string;
  statefulset: string;
  data: any;
}): Promise<any> =>
  patchJsonPatch(
    `${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/statefulsets/${statefulset}`,
    data,
  );

export const deleteStatefulSet = ({
  cluster,
  namespace,
  statefulset,
}: {
  cluster: string;
  namespace: string;
  statefulset: string;
}): Promise<any> =>
  deleteRes(
    `${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/statefulsets/${statefulset}`,
  );

/** pods */
export const getStatefulSetPods = ({
  cluster,
  namespace,
  statefulset,
  params,
}: {
  cluster: string;
  namespace: string;
  statefulset: string;
  params?: any;
}): Promise<any> =>
  get(`${PREFIX_PROXY.vapis(GROUPS.namespace)}/namespaces/${namespace}/pods`, {
    statefulsetName: statefulset,
    ...params,
  });
